<template>
  <div
    v-if="
      this.$page.props.announcement_banner && checkIfHomePage()
    "
    :id="stylesType && 'announcementBanner'"
    class="p-3 text-center bg-primary-color text-white"
  >
    <a :href="this.$page.props.announcement_banner.link" target="_blank" class="flex justify-center items-center gap-1">
      <p
        class="font-bold inline-block"
        v-html="this.$page.props.announcement_banner.title"
      ></p>
      <ChevronRightIcon class="w-5 inline-block" />
    </a>
  </div>
</template>

<script>
import { ChevronRightIcon } from "@vue-hero-icons/outline";
export default {
  props: ["stylesType"],

  components: {
    ChevronRightIcon,
  },
  methods: {
    checkIfHomePage() {
      return route().current() == "home";
    },
  },
};
</script>
 